!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n(e.moize = {});
}(this, function (e) {
  "use strict";

  var b = function b(e) {
    for (var n = new Array(e.length), t = 0; t < e.length; t++) {
      n[t] = e[t];
    }

    return n;
  },
      O = function O(e, n) {
    var r,
        i = "function" == typeof n ? n : (r = e, function (e, n) {
      if (e.length !== n.length) return !1;

      for (var t = 0; t < e.length; t++) {
        if (!r(e[t], n[t])) return !1;
      }

      return !0;
    });
    return function (e, n) {
      for (var t = 0; t < e.length; t++) {
        if (i(e[t], n)) return t;
      }

      return -1;
    };
  },
      E = function E(e, n) {
    return e === n || e != e && n != n;
  },
      j = function j(e, n, t) {},
      M = function M(e, n, t) {
    for (var r = t; r--;) {
      e[r + 1] = e[r];
    }

    e[0] = n;
  },
      q = function q(t, r, n) {
    var i = t.keys[0];
    t.values[0] = t.values[0].then(function (e) {
      return r.onCacheHit(t, r, n), r.onCacheChange(t, r, n), e;
    }).catch(function (e) {
      var n = O(r.isEqual)(t.keys, i);
      throw ~n && (t.keys.splice(n, 1), t.values.splice(n, 1)), e;
    });
  };

  function v(o, e) {
    if (o.isMemoized) return o;

    var n = e || {},
        t = n.isEqual,
        r = void 0 === t ? E : t,
        i = n.isMatchingKey,
        a = n.isPromise,
        u = void 0 !== a && a,
        c = n.maxSize,
        s = void 0 === c ? 1 : c,
        f = n.onCacheAdd,
        l = void 0 === f ? j : f,
        h = n.onCacheChange,
        p = void 0 === h ? j : h,
        g = n.onCacheHit,
        d = void 0 === g ? j : g,
        v = n.transformKey,
        y = function (e, n) {
      if (null == e) return {};
      var t,
          r,
          i = {},
          o = Object.keys(e);

      for (r = 0; r < o.length; r++) {
        t = o[r], 0 <= n.indexOf(t) || (i[t] = e[t]);
      }

      return i;
    }(n, ["isEqual", "isMatchingKey", "isPromise", "maxSize", "onCacheAdd", "onCacheChange", "onCacheHit", "transformKey"]),
        m = Object.assign({}, y, {
      isEqual: r,
      isMatchingKey: i,
      isPromise: u,
      maxSize: s,
      onCacheAdd: l,
      onCacheChange: p,
      onCacheHit: d,
      transformKey: v
    }),
        C = O(r, i),
        x = !(!v && !i),
        S = {
      keys: [],

      get size() {
        return S.keys.length;
      },

      values: []
    },
        k = S.keys,
        A = S.values;

    function z() {
      var e = x ? b(arguments) : arguments,
          n = v ? v(e) : e,
          t = C(k, n);
      if (~t) d(S, m, z), t && (M(k, k[t], t), M(A, A[t], t), p(S, m, z));else {
        k.length >= s && (k.pop(), A.pop());
        var r = x ? n : b(e),
            i = o.apply(this, arguments);
        M(k, r, k.length), M(A, i, A.length), u && q(S, m, z), l(S, m, z), p(S, m, z);
      }
      return A[0];
    }

    return Object.defineProperties(z, {
      cache: {
        configurable: !0,
        get: function get() {
          return S;
        }
      },
      cacheSnapshot: {
        configurable: !0,
        get: function get() {
          return {
            keys: b(S.keys),
            size: S.size,
            values: b(S.values)
          };
        }
      },
      isMemoized: {
        configurable: !0,
        get: function get() {
          return !0;
        }
      },
      options: {
        configurable: !0,
        get: function get() {
          return m;
        }
      }
    }), z;
  }

  var y = {
    equals: void 0,
    isDeepEqual: !1,
    isPromise: !1,
    isReact: !1,
    isSerialized: !1,
    matchesKey: void 0,
    maxAge: void 0,
    maxArgs: void 0,
    maxSize: 1 / 0,
    onExpire: void 0,
    profileName: void 0,
    serializer: void 0,
    shouldSerializeFunctions: !1,
    transformArgs: void 0,
    updateExpire: !1
  },
      m = function m() {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
      n[t] = arguments[t];
    }

    if (n.length) return n.reduce(function (e, n) {
      return "function" == typeof e ? "function" == typeof n ? function () {
        n.apply(this, arguments), e.apply(this, arguments);
      } : e : "function" == typeof n ? n : void 0;
    });
  },
      o = function o() {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
      n[t] = arguments[t];
    }

    if (n.length) return n.reduce(function (e, n) {
      return "function" == typeof e ? "function" == typeof n ? function () {
        return e(n.apply(this, arguments));
      } : e : "function" == typeof n ? n : void 0;
    });
  },
      p = function p(e, n) {
    for (var t = 0; t < e.length; t++) {
      if (e[t].key === n) return t;
    }

    return -1;
  },
      C = function C(r, e) {
    var i = "function" == typeof e ? e : function (e, n) {
      for (var t = 0; t < n.length; t++) {
        if (!r(e[t], n[t])) return !1;
      }

      return !0;
    };
    return function (e, n) {
      for (var t = 0; t < e.length; t++) {
        if (e[t].length === n.length && i(e[t], n)) return t;
      }

      return -1;
    };
  },
      u = function u(e) {
    return Array.isArray(e) ? e : [e];
  },
      x = function x(e, n) {
    return n === y ? e : Object.assign({}, e, n, {
      onCacheAdd: m(e.onCacheAdd, n.onCacheAdd),
      onCacheChange: m(e.onCacheChange, n.onCacheChange),
      onCacheHit: m(e.onCacheHit, n.onCacheHit),
      transformArgs: o(e.transformArgs, n.transformArgs)
    });
  },
      S = function S(e, n, t) {
    var r = p(e, n);
    ~r && (clearTimeout(e[r].timeoutId), t && e.splice(r, 1));
  },
      k = function k(e, n, t, r) {
    var i,
        o,
        a,
        u = n.maxAge,
        c = n.updateExpire,
        s = "number" == typeof u && isFinite(u) ? function a(u, c, s, e) {
      var n = c.maxAge,
          f = c.onCacheChange,
          l = c.onExpire,
          h = C(s, e);
      return function (t, r, i) {
        var o = t.keys[0];

        if (!~p(u, o)) {
          var e = function e() {
            var e = h(t.keys, o),
                n = t.values[e];
            ~e && (t.keys.splice(e, 1), t.values.splice(e, 1), "function" == typeof f && f(t, r, i)), S(u, o, !0), "function" == typeof l && !1 === l(o) && (t.keys.unshift(o), t.values.unshift(n), a(u, c, s)(t, r, i), "function" == typeof f && f(t, r, i));
          };

          u.push({
            expirationMethod: e,
            key: o,
            timeoutId: setTimeout(e, n)
          });
        }
      };
    }(e, n, t, r) : void 0;
    return {
      onCacheAdd: s,
      onCacheHit: s && c ? (i = e, o = n, a = o.maxAge, function (e) {
        var n = e.keys[0],
            t = p(i, n);
        ~t && (S(i, n, !1), i[t].timeoutId = setTimeout(i[t].expirationMethod, a));
      }) : void 0
    };
  },
      A = {
    anonymousProfileNameCounter: 1,
    isCollectingStats: !1,
    profiles: {}
  },
      i = !1,
      n = function n() {
    A.isCollectingStats = !0;
  },
      z = function z(e) {
    var n = new Error().stack,
        t = e.displayName || e.name || "Anonymous " + A.anonymousProfileNameCounter++;
    if (!n) return t;

    for (var r, i, o = n.split("\n").slice(3), a = 0; a < o.length; a++) {
      if (!~(r = o[a]).indexOf("/moize/") && !~r.indexOf(" (native)") && !~r.indexOf(" Function.")) {
        i = r.replace(/\n/g, "\\n").trim();
        break;
      }
    }

    return i ? t + " " + i : t;
  },
      a = function a(e, n) {
    return e ? (n / e * 100).toFixed(4) + "%" : "0%";
  },
      N = function t(e) {
    if (A.isCollectingStats || i || (console.warn('Stats are not currently being collected, please run "collectStats" to enable them.'), i = !0), e) {
      if (!A.profiles[e]) return {
        calls: 0,
        hits: 0,
        usage: "0%"
      };
      var n = A.profiles[e];
      return Object.assign({}, n, {
        usage: a(n.calls, n.hits)
      });
    }

    var r = Object.keys(A.profiles).reduce(function (e, n) {
      return e.calls += A.profiles[n].calls, e.hits += A.profiles[n].hits, e;
    }, {
      calls: 0,
      hits: 0
    });
    return Object.assign({}, r, {
      profiles: Object.keys(A.profiles).reduce(function (e, n) {
        return e[n] = t(n), e;
      }, {}),
      usage: a(r.calls, r.hits)
    });
  },
      P = function P(e) {
    return A.isCollectingStats ? {
      onCacheAdd: (r = e, i = r.profileName, A.profiles[i] || (A.profiles[i] = {
        calls: 0,
        hits: 0
      }), function () {
        A.profiles[i].calls++;
      }),
      onCacheHit: (n = e, t = n.profileName, function () {
        A.profiles[t].calls++, A.profiles[t].hits++;
      })
    } : {};
    var n, t, r, i;
  },
      H = function H(e, n) {
    var i, r, t, o, a, u, c, s, f, l, h, p, g, d, v;
    return i = e, r = n.expirations, t = i.options, o = t.isEqual, a = t.isMatchingKey, u = t.onCacheAdd, c = t.onCacheChange, s = t.transformKey, f = C(o, a), i.add = function (e, n) {
      var t = s ? s(e) : e;
      ~f(i.cache.keys, t) || (i.cache.size >= i.options.maxSize && (i.cache.keys.pop(), i.cache.values.pop()), i.cache.keys.unshift(t), i.cache.values.unshift(n), u(i.cache, i.options, i), c(i.cache, i.options, i));
    }, i.clear = function () {
      i.cache.keys.length = 0, i.cache.values.length = 0, c(i.cache, i.options, i);
    }, i.get = function (e) {
      var n = f(i.cache.keys, s ? s(e) : e);
      return ~n ? i.apply(this, i.cache.keys[n]) : void 0;
    }, i.getStats = function () {
      var e = i.options.profileName;
      return N(e);
    }, i.has = function (e) {
      return !!~f(i.cache.keys, s ? s(e) : e);
    }, i.keys = function () {
      return i.cacheSnapshot.keys;
    }, i.remove = function (e) {
      var n = f(i.cache.keys, s ? s(e) : e);

      if (~n) {
        var t = i.cache.keys[n];
        i.cache.keys.splice(n, 1), i.cache.values.splice(n, 1), c(i.cache, i.options, i), S(r, t, !0);
      }
    }, i.update = function (e, n) {
      var t = f(i.cache.keys, s ? s(e) : e);

      if (~t) {
        var r = i.cache.keys[t];
        M(i.cache.keys, r, t), M(i.cache.values, n, t), c(i.cache, i.options, i);
      }
    }, i.values = function () {
      return i.cacheSnapshot.values;
    }, l = e, p = (h = n).expirations, g = h.options, d = h.originalFunction, v = l.options, Object.defineProperties(l, {
      _microMemoizeOptions: {
        configurable: !0,
        get: function get() {
          return v;
        }
      },
      expirations: {
        configurable: !0,
        get: function get() {
          return p;
        }
      },
      expirationsSnapshot: {
        configurable: !0,
        get: function get() {
          return p.slice(0);
        }
      },
      isCollectingStats: {
        configurable: !0,
        get: function get() {
          return A.isCollectingStats;
        }
      },
      isMoized: {
        configurable: !0,
        get: function get() {
          return !0;
        }
      },
      options: {
        configurable: !0,
        get: function get() {
          return g;
        }
      },
      originalFunction: {
        configurable: !0,
        get: function get() {
          return d;
        }
      }
    }), g.isReact && (l.contextTypes = d.contextTypes, l.defaultProps = d.defaultProps, l.displayName = "Moized(" + (d.displayName || d.name || "Component") + ")", l.propTypes = d.propTypes), e;
  },
      K = "function" == typeof Map,
      F = "function" == typeof Set,
      c = "function" == typeof WeakSet,
      s = Object.keys,
      f = function f(e, n) {
    return e && "object" == typeof e && n.add(e);
  },
      l = function l(e, n, t, r) {
    for (var i = 0; i < e.length; i++) {
      if (t(e[i], n, r)) return !0;
    }

    return !1;
  },
      h = function h(e, n, t, r) {
    if (e.length !== n.length) return !1;

    for (var i = 0; i < e.length; i++) {
      if (!l(n, e[i], t, r)) return !1;
    }

    return !0;
  },
      w = function w(e, n) {
    return e === n || e != e && n != n;
  },
      R = function R(e) {
    return e.constructor === Object;
  },
      T = function T(e) {
    return "function" == typeof e.then;
  },
      g = function g(e) {
    return !(!e.$$typeof || !e._store);
  },
      t = function t(n) {
    return function (e) {
      var o = n || e;
      return function (e, n) {
        var t = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : c ? new WeakSet() : Object.create({
          _values: [],
          add: function add(e) {
            this._values.push(e);
          },
          has: function has(e) {
            return !!~this._values.indexOf(e);
          }
        }),
            r = t.has(e),
            i = t.has(n);
        return r || i ? r && i : (f(e, t), f(n, t), o(e, n, t));
      };
    };
  },
      d = function d(e) {
    var t = {
      keys: [],
      values: []
    };
    return e.forEach(function (e, n) {
      return t.keys.push(n) && t.values.push(e);
    }), t;
  },
      r = function r(e) {
    var i = e ? function (e, n, t, r) {
      return h(e.keys, n.keys, t, r) && h(e.values, n.values, t, r);
    } : function (e, n, t, r) {
      return h(e.values, n.values, t, r);
    };
    return function (e, n, t, r) {
      return i(d(e), d(n), t, r);
    };
  },
      _ = function _(e, n, t, r) {
    var i = s(e),
        o = s(n);
    if (i.length !== o.length) return !1;

    for (var a = void 0, u = 0; u < i.length; u++) {
      if (a = i[u], !l(o, a, w)) return !1;
      if (("_owner" !== a || !g(e) || !g(n)) && !t(e[a], n[a], r)) return !1;
    }

    return !0;
  },
      D = Array.isArray,
      I = r(!0),
      J = r(!1),
      W = function W(e) {
    var v = "function" == typeof e ? e(n) : n;

    function n(e, n, t) {
      if (w(e, n)) return !0;
      var r = typeof e;
      if (r !== typeof n || "object" !== r || !e || !n) return !1;
      if (R(e) && R(n)) return _(e, n, v, t);
      var i = D(e),
          o = D(n);
      if (i || o) return i === o && function (e, n, t, r) {
        if (e.length !== n.length) return !1;

        for (var i = 0; i < e.length; i++) {
          if (!t(e[i], n[i], r)) return !1;
        }

        return !0;
      }(e, n, v, t);
      var a = e instanceof Date,
          u = n instanceof Date;
      if (a || u) return a === u && w(e.getTime(), n.getTime());
      var c,
          s,
          f = e instanceof RegExp,
          l = n instanceof RegExp;
      if (f || l) return f === l && (s = n, (c = e).source === s.source && c.global === s.global && c.ignoreCase === s.ignoreCase && c.multiline === s.multiline && c.unicode === s.unicode && c.sticky === s.sticky && c.lastIndex === s.lastIndex);
      if (T(e) || T(n)) return e === n;

      if (K) {
        var h = e instanceof Map,
            p = n instanceof Map;
        if (h || p) return h === p && I(e, n, v, t);
      }

      if (F) {
        var g = e instanceof Set,
            d = n instanceof Set;
        if (g || d) return g === d && J(e, n, v, t);
      }

      return _(e, n, v, t);
    }

    return n;
  },
      $ = (W(t()), W(t(w)), W()),
      B = W(function () {
    return w;
  }),
      G = function G(n) {
    return function (e) {
      if (n >= e.length) return e;

      switch (n) {
        case 0:
          return [];

        case 1:
          return [e[0]];

        case 2:
          return [e[0], e[1]];

        case 3:
          return [e[0], e[1], e[2]];

        case 4:
          return [e[0], e[1], e[2], e[3]];

        case 5:
          return [e[0], e[1], e[2], e[3], e[4]];
      }

      return Array.prototype.slice.call(e, 0, n);
    };
  },
      L = function L(e, n, t) {
    return "[ref-" + t + "]";
  },
      Q = function Q(e, n) {
    for (var t = 0; t < e.length; t++) {
      if (e[t] === n) return t;
    }

    return -1;
  },
      U = function U(t, e) {
    var r = e || L,
        i = "function" == typeof t,
        o = [],
        a = void 0,
        u = void 0;
    return function (e, n) {
      if (o.length) {
        if (~(a = Q(o, this)) ? o = function (e, n) {
          for (var t = new Array(n), r = 0; r < n; r++) {
            t[r] = e[r];
          }

          return t;
        }(o, a + 1) : o[o.length] = this, ~(u = Q(o, n))) return r.call(this, e, n, u);
      } else o[0] = n;

      return i ? t.call(this, e, n) : n;
    };
  };

  var V = function V(e, n) {
    return "function" == typeof n ? "" + n : n;
  },
      X = function X(n, t) {
    try {
      return JSON.stringify(n, t);
    } catch (e) {
      return r = n, i = t, JSON.stringify(r, U(i, a), o);
    }

    var r, i, o, a;
  },
      Y = function Y(e) {
    return "function" == typeof e.serializer ? o(u, e.serializer) : (a = e.shouldSerializeFunctions ? V : null, function (e) {
      for (var n, t, r, i = "|", o = 0; o < e.length; o++) {
        i += (n = e[o], t = a, r = typeof n, (!n || "object" !== r && "function" !== r ? n : X(n, t)) + "|");
      }

      return [i];
    });
    var a;
  },
      Z = function Z(e, n) {
    return e[0] === n[0];
  },
      ee = function ee(r) {
    if ("function" == typeof r) return function (e, n, t) {
      return r(t.cache, t.options, t);
    };
  },
      ne = function ne(e) {
    var n = e.equals,
        t = e.isDeepEqual,
        r = e.isReact;
    return n || t && $ || r && B || w;
  },
      te = function te(e) {
    var n = e.isSerialized;
    return e.matchesKey || n && Z || void 0;
  },
      re = function re(e) {
    var n = e.maxArgs,
        t = e.isReact,
        r = e.isSerialized,
        i = e.transformArgs;
    return o(r && Y(e), "function" == typeof i && o(u, i), t && G(2), "number" == typeof n && G(n));
  };

  function ie(t, e) {
    if (void 0 === e && (e = y), t.isMoized) return ie(t.originalFunction, x(t.options, e));
    if ("object" == typeof t) return function (e, n) {
      return void 0 === n && (n = {}), "function" == typeof e ? ie(e, x(t, n)) : ie(x(t, e));
    };
    var n = Object.assign({}, y, e, {
      profileName: e.profileName || z(t)
    }),
        r = [],
        i = (n.equals, n.isDeepEqual, n.isPromise),
        o = (n.isReact, n.isSerialized, n.matchesKey, n.maxAge, n.maxArgs, n.maxSize),
        a = n.onCacheAdd,
        u = n.onCacheChange,
        c = n.onCacheHit,
        s = (n.onExpire, n.profileName, n.shouldSerializeFunctions, n.serializer, n.transformArgs, n.updateExpire, function (e, n) {
      if (null == e) return {};
      var t,
          r,
          i = {},
          o = Object.keys(e);

      for (r = 0; r < o.length; r++) {
        t = o[r], 0 <= n.indexOf(t) || (i[t] = e[t]);
      }

      return i;
    }(n, ["equals", "isDeepEqual", "isPromise", "isReact", "isSerialized", "matchesKey", "maxAge", "maxArgs", "maxSize", "onCacheAdd", "onCacheChange", "onCacheHit", "onExpire", "profileName", "shouldSerializeFunctions", "serializer", "transformArgs", "updateExpire"])),
        f = ne(n),
        l = te(n),
        h = k(r, n, f, l),
        p = P(n),
        g = re(n),
        d = Object.assign({}, s, {
      isEqual: f,
      isMatchingKey: l,
      isPromise: i,
      maxSize: o,
      onCacheAdd: ee(m(a, h.onCacheAdd, p.onCacheAdd)),
      onCacheChange: ee(u),
      onCacheHit: ee(m(c, h.onCacheHit, p.onCacheHit)),
      transformKey: g
    });
    return H(v(t, d), {
      expirations: r,
      options: n,
      originalFunction: t
    });
  }

  ie.collectStats = n, ie.compose = function () {
    return o.apply(null, arguments) || ie;
  }, ie.deep = ie({
    isDeepEqual: !0
  }), ie.getStats = N, ie.isCollectingStats = function () {
    return A.isCollectingStats;
  }, ie.isMoized = function (e) {
    return "function" == typeof e && !!e.isMoized;
  }, ie.maxAge = function (e) {
    return ie({
      maxAge: e
    });
  }, ie.maxArgs = function (e) {
    return ie({
      maxArgs: e
    });
  }, ie.maxSize = function (e) {
    return ie({
      maxSize: e
    });
  }, ie.promise = ie({
    isPromise: !0,
    updateExpire: !0
  }), ie.react = ie({
    isReact: !0
  }), ie.reactSimple = ie({
    isReact: !0,
    maxSize: 1
  }), ie.serialize = ie({
    isSerialized: !0
  }), ie.simple = ie({
    maxSize: 1
  }), e.collectStats = n, e.default = ie, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});